const defaultState = {
  name: '',
  shortName: '',
  position: '',
  code: '',
  errors: {},
  mealCategory: null,
  mealCategoryOptions: [],
  codeV4: '',
};

export default defaultState;
